import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { toast } from "react-toastify";
import ConfirmationModal from "../Shared/ConfirmationModal";
import FoodMetricForm from "./FoodMetricForm";
import FoodMetricTable from "./FoodMetricTable";

import { mealConfigsServiceApi } from "./services/MealConfigServices";
class ManagedFoodMetric extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            selectedRow: null,
            hasParams: false,
            error: null,
            pageNum: 0,
            pageSize: 5,
            pages: null,
            showModal: false,
            submitSucessful: false,
            filterParams: null,
            // showNextJoyRide: false,
            // showJoyRideOnTable: false,
        };
        this.resetButton = this.resetButton.bind(this);
    }

    componentDidMount() {
        const { pageNum, pageSize } = this.state;
        this.getAllFoodMetric({ "page-num": pageNum + 1, "page-size": pageSize });
    }
    getAllFoodMetric = (params) => {
        this.setState({ fetching: true });
        mealConfigsServiceApi
            .getAllFoodMeasureServices(params)
            .then((response) => {
              
                response &&
                    this.setState({
                        data: response,
                        pages: Math.ceil(response.count / params["page-size"]),
                        error: null,
                        fetching: false,
                    });
            })
            .catch((error) => this.setState({ error, fetching: false }));
    };

    updateFoodMeasure = async (data) => {
        const { pageSize, selectedRow } = this.state;

        this.setState({
            ...this.state,
            submitting: true,
            formError: null,
            submitSucessful: false,
            data: null,
        });

        try {
            let response = await mealConfigsServiceApi.updateFoodMeasureService(data, selectedRow && selectedRow.id);
            if (response) {
                toast.success("Food metric updated successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.resetButton();
                //this.setState({ submitSucessful: true ,submitting:false});
                //update table...
                this.getAllFoodMetric({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };

    addFoodMetricSetting = async (metric) => {
        const { pageSize } = this.state;

        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
            data: null,
        });
        try {
            let response = await mealConfigsServiceApi.creteFoodMeasureService(metric);
            if (response) {
                toast.success("Food metric created successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                this.setState({ submitSucessful: true, submitting: false });
                //get the call for the table data.
                this.getAllFoodMetric({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };

    selectRow = (selectedRow) => {
        this.setState({ selectedRow: selectedRow.original, hasParams: true });
    };

    deleteFormMeteric = async (item) => {
        const { pageSize, selectedRow } = this.state;
        try {
            let response = await mealConfigsServiceApi.deleteFoodMeasureService(selectedRow && selectedRow.id);
            if (response) {
                toast.success("Food metric deleted successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.resetButton();
                //update table...
                this.getAllFoodMetric({ "page-num": 1, "page-size": pageSize });
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
                showModal: !this.state.showModal,
            });
        }
    };

    showConfirmation = (selectedRow) => {
        this.setState({
            selectedRow: selectedRow.original,
            showModal: !this.state.showModal,
        });
    };

    resetButton = () => {
        this.setState({
            hasParams: false,
            submitting: false,
            selectRow: null,
            submitSucessful: false,
        });
    };

    fetchData = () => {
        const { pageNum, pageSize, filterParams } = this.state;
        let params = { "page-num": pageNum + 1, "page-size": pageSize };
        if (filterParams) {
            params = { ...filterParams, ...params };
        }
        // this.getAllCategories(params);
        this.getAllFoodMetric(params);
    };

    setPageNumber = (pageIndex) => {
        this.setState({ pageNum: pageIndex }, () => this.fetchData());
    };

    setPageSize = (pageSize, pageIndex) => {
        this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
    };

    filterData = (params) => {
        this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
    };

    render() {
        const { fetching, data, pages, pageNum, pageSize, error, submitting, formError, hasParams, selectedRow, clearDescription, submitSucessful } = this.state;
        return (
            <div>
                <section className={"mb-3"}>
                    <FoodMetricForm submitting={submitting} error={formError} hasParams={hasParams} clearDescription={clearDescription} selectedRow={selectedRow} submitAction={this.addFoodMetricSetting} reset={this.resetButton} submitSucessful={submitSucessful} editAction={this.updateFoodMeasure} />
                </section>

                <section>
                    <FoodMetricTable
                        fetching={fetching}
                        hasParams={hasParams}
                        selectedRow={selectedRow}
                        data={data}
                        pages={pages}
                        page={pageNum}
                        pageSize={pageSize}
                        selectRow={this.selectRow}
                        error={error}
                        filterData={this.filterData}
                        DeleteModal={this.DeleteModal}
                        deleteFormMeteric={this.deleteFormMeteric}
                        showModal={this.showConfirmation}
                        setPageNumber={this.setPageNumber}
                        setPageSize={this.setPageSize}
                    />
                </section>
                <ConfirmationModal isOpen={this.state.showModal} showModal={this.showConfirmation} action={this.deleteFormMeteric} item={selectedRow} />
            </div>
        );
    }
}

export default ManagedFoodMetric;
